var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.resumo)?_c('apuracao-acao-detalhes-resumo-execucao',{attrs:{"resumoExec":_vm.resumo,"exibe-titulo":false}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }